export default {
    // Header Section
    "discover_your": "మీ దాన్ని కనుగొనండి",
    "know_your": "మీ సంవత్సర జ్యోతిష్య",
    "year_analysis": "విశ్లేషణను తెలుసుకోండి",
    "yearly_cosmic_insights": "వార్షిక కాస్మిక్ అంతర్దృష్టులు",
    "year_analysis_description": "20.	వేద జ్యోతిష్యం మరియు న్యూమరాలజీ ఆధారంగా సమగ్ర వార్షిక విశ్లేషణ పొందండి. శుభమయమైన కాలాలు, మాసిక జ్యోతిష్య సూచనలు, సవాళ్లు మరియు విజయానికి అవసరమైన వ్యక్తిగత మార్గదర్శకతను తెలుసుకోండి.",


    // Service Information
    "enter_details_for_year_analysis": "సంవత్సర విశ్లేషణ కోసం మీ వివరాలను నమోదు చేయండి",
    "complete_year_analysis": "పూర్ణ సంవత్సర విశ్లేషణ",
    "service_price": "సేవా ధర",
    "comprehensive_year_analysis_note": "మాసిక భవిష్యవాణులు మరియు సమయ మార్గదర్శనంతో వివరణాత్మక వార్షిక అంచనా",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
    "name_yearly_influence": "మీ పేరు వార్షిక కంపనలు మరియు వార్షిక చక్రాలను ప్రభావితం చేస్తుంది",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబరును నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_yearly_cycles": "వ్యక్తిగత సంవత్సర చక్రాలు మరియు వార్షిక భవిష్యవాణులను గణించడానికి అవసరం",
    "analysis_year": "విశ్లేషణ సంవత్సరం",
    "year_2024": "2024",
    "year_2025": "2025",
    "year_2026": "2026",
    "select_year_for_analysis": "మీరు వివరణాత్మక విశ్లేషణ కోరుకునే సంవత్సరాన్ని ఎంచుకోండి",
    "preferred_language": "ప్రాధాన్య భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ సంవత్సర విశ్లేషణ ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core Year Features
    "complete_yearly_forecast": "పూర్ణ వార్షిక అంచనా",
    "monthly_breakdown_analysis": "మాసిక విభజన విశ్లేషణ",
    "major_life_events_timing": "ప్రధాన జీవిత సంఘటనల సమయం",
    "favorable_unfavorable_periods": "అనుకూల మరియు ప్రతికూల కాలాలు",
    "yearly_remedies_guidance": "వార్షిక పరిహారాలు మరియు మార్గదర్శనం",
    "pdf_download": "సమగ్ర PDF నివేదిక",

    "what_you_get": "మీ సంవత్సర విశ్లేషణలో ఉన్నవి",
    "comprehensive_yearly_roadmap": "సమగ్ర వార్షిక రోడ్‌మ్యాప్",
    "month_by_month_predictions": "నెల వారీ భవిష్యవాణులు",
    "auspicious_timing_guide": "మంగళకర సమయ గైడ్",
    "yearly_remedial_solutions": "వార్షిక పరిహార పరిష్కారాలు",

    // Actions & Buttons
    "pay_and_generate_analysis": "నా సంవత్సర విశ్లేషణ పొందండి",
    "processing_payment": "చెల్లింపును ప్రాసెస్ చేస్తోంది",
    "processing_request": "విశ్లేషణను రూపొందిస్తోంది",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "year_analysis_processing": "మీ సమగ్ర సంవత్సర విశ్లేషణ మా నిపుణ జ్యోతిష్యులచే తయారు చేయబడుతోంది. వివరణాత్మక మాసిక భవిష్యవాణులు మరియు వార్షిక మార్గదర్శనం అందుకుంటారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "చెల్లింపు ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "విశ్లేషణ డెలివరీ",
    "within_18_hours_delivery_note": "మీ వివరణాత్మక సంవత్సర విశ్లేషణ 18 గంటలలోపు తయారవుతుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్‌లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్‌లను అందుకోండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి విశ్లేషణ అందించబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ సంవత్సర విశ్లేషణ ప్యాకేజ్",
    "detailed_year_analysis": "వివరణాత్మక సంవత్సర విశ్లేషణ నివేదిక (PDF)",
    "monthly_predictions_calendar": "మాసిక భవిష్యవాణుల కేలెండర్",
    "auspicious_dates_timing": "మంగళకరమైన తేదీలు మరియు సమయం",
    "yearly_remedies_guide": "వార్షిక పరిహారాల గైడ్",
    "life_events_forecast": "జీవిత సంఘటనల అంచనా",

    // Visual Content
    "sample_year_analysis": "నమూనా సంవత్సర విశ్లేషణ",
    "yearly_theme": "వార్షిక థీమ్",
    "sample_yearly_reading": "ఆర్థిక స్థిరత్వ దృష్టితో వృద్ధి మరియు రూపాంతరం",
    "sample_year_preview": "మాసిక అంతర్దృష్టులతో మీ వ్యక్తిగత సంవత్సర విశ్లేషణ మునుజూపు",
    "monthly_overview": "మాసిక సమీక్ష",

    // Month Abbreviations
    "jan": "జన",
    "feb": "ఫిబ్రవరి",
    "mar": "మార్చి",
    "apr": "ఏప్రిల్",
    "may": "మే",
    "jun": "జూన్",
    "jul": "జులై",
    "aug": "ఆగస్టు",
    "sep": "సెప్టెంబర్",
    "oct": "అక్టోబర్",
    "nov": "నవంబర్",
    "dec": "డిసెంబర్",

    // Status & Processing
    "your_year_analysis_status": "మీ సంవత్సర విశ్లేషణ స్థితి",
    "processing_your_analysis": "మీ సంవత్సరాన్ని విశ్లేషిస్తోంది",
    "analysis_processing_message": "మా నిపుణ జ్యోతిష్యులు మాసిక భవిష్యవాణులు మరియు సమయ మార్గదర్శనంతో మీ సమగ్ర సంవత్సర విశ్లేషణను తయారు చేస్తున్నారు.",
    "request_id": "విశ్లేషణ ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో ఉంది",
    "pending": "వేచి ఉంది",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్‌లు ప్రారంభించబడ్డాయి",
    "delivery_within_18_hours": "18 గంటలలోపు నివేదిక సిద్ధం",

    // Support & Contact
    "contact_support": "సంవత్సర విశ్లేషణ మద్దతును సంప్రదించండి",
    "need_help": "మార్గదర్శనం కావాలా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అవసరమైన అన్ని వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "విశ్లేషణ ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // Year-Specific Elements
    "personal_year_number": "వ్యక్తిగత సంవత్సర సంఖ్య",
    "annual_theme": "వార్షిక థీమ్",
    "year_vibration": "సంవత్సర కంపనలు",
    "yearly_cycles": "వార్షిక చక్రాలు",
    "annual_lessons": "వార్షిక పాఠాలు",
    "year_challenges": "సంవత్సర సవాళ్లు",

    // Monthly Analysis
    "january_analysis": "జనవరి విశ్లేషణ",
    "february_analysis": "ఫిబ్రవరి విశ్లేషణ",
    "march_analysis": "మార్చి విశ్లేషణ",
    "april_analysis": "ఏప్రిల్ విశ్లేషణ",
    "may_analysis": "మే విశ్లేషణ",
    "june_analysis": "జూన్ విశ్లేషణ",
    "july_analysis": "జులై విశ్లేషణ",
    "august_analysis": "ఆగస్టు విశ్లేషణ",
    "september_analysis": "సెప్టెంబర్ విశ్లేషణ",
    "october_analysis": "అక్టోబర్ విశ్లేషణ",
    "november_analysis": "నవంబర్ విశ్లేషణ",
    "december_analysis": "డిసెంబర్ విశ్లేషణ",

    // Quarterly Analysis
    "first_quarter": "మొదటి త్రైమాసికం (జన-మార్చి)",
    "second_quarter": "రెండవ త్రైమాసికం (ఏప్రిల్-జూన్)",
    "third_quarter": "మూడవ త్రైమాసికం (జులై-సెప్టెంబర్)",
    "fourth_quarter": "నాలుగవ త్రైమాసికం (అక్టోబర్-డిసెంబర్)",
    "quarterly_themes": "త్రైమాసిక థీమ్‌లు",
    "seasonal_influences": "కాలానుగుణ ప్రభావాలు",

    // Life Areas Yearly Focus
    "career_year_focus": "కెరీర్ సంవత్సర దృష్టి",
    "love_relationships_year": "ప్రేమ మరియు సంబంధాల సంవత్సరం",
    "health_wellness_year": "ఆరోగ్యం మరియు క్షేమం సంవత్సరం",
    "financial_year_outlook": "ఆర్థిక సంవత్సర దృక్పథం",
    "family_social_year": "కుటుంబ మరియు సామాజిక సంవత్సరం",
    "spiritual_growth_year": "ఆధ్యాత్మిక వృద్ధి సంవత్సరం",

    // Timing & Periods
    "peak_success_periods": "శిఖర విజయ కాలాలు",
    "challenging_periods": "సవాలు కాలాలు",
    "neutral_periods": "తటస్థ కాలాలు",
    "transformation_phases": "రూపాంతర దశలు",
    "opportunity_windows": "అవకాశ కిటికీలు",
    "caution_periods": "జాగ్రత్త కాలాలు",

    // Auspicious Timing
    "best_months_for_new_ventures": "కొత్త వెంచర్లకు అత్యుత్తమ నెలలు",
    "favorable_travel_periods": "అనుకూల ప్రయాణ కాలాలు",
    "auspicious_wedding_dates": "మంగళకరమైన వివాహ తేదీలు",
    "good_investment_timing": "మంచి పెట్టుబడి సమయం",
    "career_change_timing": "కెరీర్ మార్పు సమయం",
    "property_purchase_timing": "ఆస్తి కొనుగోలు సమయం",

    // Annual Predictions
    "career_predictions": "కెరీర్ భవిష్యవాణులు",
    "business_forecast": "వ్యాపార అంచనా",
    "financial_outlook": "ఆర్థిక దృక్పథం",
    "relationship_predictions": "సంబంధ భవిష్యవాణులు",
    "health_forecast": "ఆరోగ్య అంచనా",
    "family_predictions": "కుటుంబ భవిష్యవాణులు",

    // Success Factors
    "key_success_factors": "ప్రధాన విజయ కారకాలు",
    "growth_opportunities": "వృద్ధి అవకాశాలు",
    "skill_development_focus": "నైపుణ్య అభివృద్ధి దృష్టి",
    "networking_opportunities": "నెట్‌వర్కింగ్ అవకాశాలు",
    "leadership_potential": "నాయకత్వ సంభావ్యత",
    "creative_expression": "సృజనాత్మక వ్యక్తీకరణ",

    // Challenges & Solutions
    "potential_obstacles": "సంభావ్య అడ్డంకులు",
    "problem_solving_guidance": "సమస్య పరిష్కార మార్గదర్శనం",
    "stress_management": "ఒత్తిడి నిర్వహణ",
    "conflict_resolution": "వివాద పరిష్కారం",
    "decision_making_support": "నిర్ణయ తీసుకునే మద్దతు",
    "risk_mitigation": "ప్రమాద తగ్గింపు",

    // Personal Development
    "character_development": "వ్యక్తిత్వ అభివృద్ధి",
    "habit_formation": "లాభదాయకమైన అలవాటు ఏర్పాటు",
    "goal_setting_guidance": "లక్ష్య నిర్ణయ మార్గదర్శనం",
    "motivation_factors": "ప్రేరణ కారకాలు",
    "confidence_building": "ఆత్మవిశ్వాసం నిర్మాణం",
    "self_improvement_areas": "స్వీయ అభివృద్ధి రంగాలు",

    // Relationship Year
    "love_life_forecast": "ప్రేమ జీవిత అంచనా",
    "marriage_prospects": "వివాహ అవకాశాలు",
    "family_harmony": "కుటుంబ సామరస్యం",
    "friendship_developments": "మిత్రత్వ అభివృద్ధిలు",
    "social_connections": "సామాజిక సంబంధాలు",
    "partnership_opportunities": "భాగస్వామ్య అవకాశాలు",

    // Financial Year
    "income_growth_potential": "ఆదాయ వృద్ధి సంభావ్యత",
    "expenditure_patterns": "వ్యయ నమూనాలు",
    "investment_guidance": "పెట్టుబడి మార్గదర్శనం",
    "debt_management": "రుణ నిర్వహణ",
    "savings_opportunities": "పొదుపు అవకాశాలు",
    "financial_planning": "ఆర్థిక ప్రణాళిక",

    // Health Year
    "vitality_levels": "జీవశక్తి స్థాయిలు",
    "health_maintenance": "ఆరోగ్య నిర్వహణ",
    "fitness_goals": "ఫిట్‌నెస్ లక్ష్యాలు",
    "wellness_practices": "ఆరోగ్య అభ్యాసాలు",
    "preventive_care": "నివారణ సంరక్షణ",
    "mental_health_focus": "మానసిక ఆరోగ్య దృష్టి",

    // Career Year
    "professional_growth": "వృత్తిపరమైన వృద్ధి",
    "job_opportunities": "ఉద్యోగ అవకాశాలు",
    "skill_enhancement": "నైపుణ్య మెరుగుదల",
    "leadership_roles": "నాయకత్వ పాత్రలు",
    "career_transitions": "కెరీర్ పరివర్తనలు",
    "recognition_achievements": "గుర్తింపు మరియు సాధనలు",

    // Spiritual Year
    "spiritual_awakening": "ఆధ్యాత్మిక మేల్కొలుపు",
    "meditation_practices": "ధ్యాన అభ్యాసాలు",
    "inner_growth": "అంతర్గత వృద్ధి",
    "wisdom_development": "జ్ఞాన అభివృద్ధి",
    "divine_connections": "దైవిక సంబంధాలు",
    "karmic_lessons": "కర్మ పాఠాలు",

    // Travel & Adventure
    "travel_opportunities": "ప్రయాణ అవకాశాలు",
    "adventure_potential": "సాహస సంభావ్యత",
    "cultural_experiences": "సాంస్కృతిక అనుభవాలు",
    "educational_journeys": "విద్యా యాత్రలు",
    "pilgrimage_possibilities": "తీర్థయాత్ర అవకాశాలు",
    "foreign_connections": "విదేశీ సంబంధాలు",

    // Learning & Education
    "learning_opportunities": "అభ్యాస అవకాశాలు",
    "skill_certifications": "నైపుణ్య సర్టిఫికేషన్లు",
    "knowledge_expansion": "జ్ఞాన విస్తరణ",
    "teaching_possibilities": "బోధన అవకాశాలు",
    "research_projects": "పరిశోధన ప్రాజెక్ట్లు",
    "academic_pursuits": "అకడమిక్ కార్యకలాపాలు",

    // Creative & Artistic
    "creative_projects": "సృజనాత్మక ప్రాజెక్ట్లు",
    "artistic_expression": "కళాత్మక వ్యక్తీకరణ",
    "innovative_ideas": "ఆవిష్కరణ ఆలోచనలు",
    "creative_collaborations": "సృజనాత్మక సహకారాలు",
    "artistic_recognition": "కళాత్మక గుర్తింపు",
    "creative_income": "సృజనాత్మక ఆదాయ సంభావ్యత",

    // Social & Community
    "community_involvement": "కమ్యూనిటీ పాల్గొనడం",
    "social_influence": "సామాజిక ప్రభావం",
    "public_recognition": "ప్రజా గుర్తింపు",
    "group_activities": "సమూహ కార్యకలాపాలు",
    "social_causes": "సామాజిక కారణాలు",
    "humanitarian_work": "మానవతావాద పని",

    // Technology & Innovation
    "technological_adaptation": "సాంకేతిక అనుకూలనం",
    "digital_opportunities": "డిజిటల్ అవకాశాలు",
    "innovation_potential": "ఆవిష్కరణ సంభావ్యత",
    "online_presence": "ఆన్‌లైన్ ఉనికి",
    "tech_skill_development": "టెక్ నైపుణ్య అభివృద్ధి",
    "digital_transformation": "డిజిటల్ రూపాంతరం"
};
